export { default } from "./menu-open-closed-indicator";
